import React from 'react';
import {useControllerProps} from '../Widget/ControllerContext';
import {classes} from './Footer.st.css';
import {InnerFooter} from '../../../common/components/InnerFooter/InnerFooter';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../common/constants';

export const Footer = ({dataHook}: {dataHook: string}) => {
  const {
    checkoutSettingsStore: {
      checkoutSettings: {termsAndConditions, privacyPolicy, returnPolicy, contactUs, customPolicy, digitalPolicy},
    },
    checkoutStore: {cart, onPolicyClicked},
  } = useControllerProps();
  const shouldCheckLineItemPolicies = Object.keys(cart.lineItemPolicies || /* istanbul ignore next */ {}).length <= 0;
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);

  if (
    !checkoutUIRevampOrderSummary &&
    !termsAndConditions.enabled &&
    !privacyPolicy.enabled &&
    !returnPolicy.enabled &&
    !contactUs.enabled &&
    !customPolicy.enabled &&
    !(digitalPolicy.enabled && cart.hasDigitalItems) &&
    cart.paymentPolicies.length === 0 &&
    shouldCheckLineItemPolicies
  ) {
    return null;
  }

  return (
    <div className={classes.footer} data-hook={dataHook}>
      <InnerFooter
        termsAndConditions={termsAndConditions}
        privacyPolicy={privacyPolicy}
        returnPolicy={returnPolicy}
        digitalPolicy={digitalPolicy}
        contactUs={contactUs}
        customPolicy={customPolicy}
        shouldShowDigitalItemPolicy={cart.hasDigitalItems}
        paymentPolicies={cart.paymentPolicies}
        lineItemPolicies={cart.lineItemPolicies}
        onPolicyClicked={onPolicyClicked}
      />
    </div>
  );
};
